import styled from 'styled-components';
import Button from '@material-ui/core/Button';

export const Container = styled.div`
  position: relative;
  padding-bottom: 60px;
  background-color: white;
`;

export const SubjectDetailFormContainer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: ${({ wrap }) => wrap || 'initial'};
`;

export const FieldColumn = styled.div`
  width: ${({ width }) => width || '25%'};
  padding: ${({ padding }) => padding || '20px'};
`;

export const InfoBlock = styled.div`
  width: ${({ width }) => width || '33%'};
  border: 1px solid #ccc;
  margin: 10px;
  margin-top: 15px;
  padding: 10px;
`;

export const FormGroupTitleContainer = styled.div`
  position: relative;
`;

export const FormGroupTitle = styled.h5`
  background-color: #fff;
  position: absolute;
  top: -30px;
  padding-left: 5px;
  padding-right: 5px;
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
`;

export const CalendarInputContainer = styled.div`
  position: relative;
  flex: 1;
  min-width: 0;
  line-height: 30px;

  span {
    position: absolute;
    left: 10px;
  }

  input {
    padding-left: 30px;
  }
`;

export const ButtonContainer = styled.div`
  position: absolute;
  right: 20px;
  text-align: right;
  bottom: 20px;
`;

export const StyledButton = styled(Button)`
  &&& {
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    cursor: ${({ preview }) => !preview && 'pointer'};
    background-color: #36449d;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.24);
    color: #fff;
    min-width: 90px;
  }
`;
